import {Link} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const ProgressTrackingLink = (_context: NavigationContext): Link => ({
    type: 'link',
    label: 'navigation.graph_humanum_menu_link',
    link: '/graph-humanum/multi',
    icon: 'navigation-link__list-item',
});